module.exports = __webpack_public_path__ + "img/5. Price List_2.1f1cbf49.jpg";